<template>
  <div id="brand" class="card card-body mt-4">
    <div class="row justify-content-center align-items-center">
      <div class="col-sm-auto col-8 my-auto">
        <div class="h-100">
          <h5 class="mb-1 font-weight-bolder">{{ brand?.name || brand_title}}</h5>
        </div>
      </div>
    </div>
  </div>
  <form class="text-start needs-validation" novalidate @submit.prevent="onSubmit">
    <div id="basic-info" class="card mt-4">
      <div class="card-header">
        <h5>{{ $t('key_brand_information') }}</h5>
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-6">
            <label class="form-label text-primary">{{ $t('key_brand_name') }} <span style="color:red">*</span></label>
            <Input id="brandName" :value="brand?.name" :error="!!errors?.name && validated" :error-message="translate_error(validated, errors?.name)" :is-required="true" type="text" :placeholder="$t('key_brand_name_placeholder')" @update:value="val => brand.name = val"/>
          </div>
          <div class="col-6">
            <label class="form-label">{{ $t('key_brand_category') }}</label>
            <select
              id="choices-brand-category"
              class="form-control"
              name="choices-brand-category"
              placeholder="test"
            ></select>






            <label class="form-label">Last Name</label>
            <soft-input id="lastName" type="text" placeholder="Thompson" />
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4 col-6">
            <label class="form-label mt-2">I'm</label>
            <select
              id="choices-gender"
              class="form-control"
              name="choices-gender"
            >
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </select>
          </div>
          <div class="col-sm-8">
            <div class="row">
              <div class="col-sm-5 col-5">
                <label class="form-label mt-2">Birth Date</label>
                <select
                  id="choices-month"
                  class="form-control"
                  name="choices-month"
                ></select>
              </div>
              <div class="col-sm-4 col-3">
                <label class="form-label mt-2">&nbsp;</label>
                <select
                  id="choices-day"
                  class="form-control"
                  name="choices-day"
                ></select>
              </div>
              <div class="col-sm-3 col-4">
                <label class="form-label mt-2">&nbsp;</label>
                <select
                  id="choices-year"
                  class="form-control"
                  name="choices-year"
                ></select>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <label class="form-label mt-2">Email</label>
            <soft-input id="email" type="email" placeholder="example@email.com" />
          </div>
          <div class="col-6">
            <label class="form-label mt-2">Confirmation Email</label>
            <soft-input
              id="confirmEmail"
              type="email"
              placeholder="example@email.com"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <label class="form-label mt-2">Your location</label>
            <soft-input id="location" type="text" placeholder="Sydney, A" />
          </div>
          <div class="col-6">
            <label class="form-label mt-2">Phone Number</label>
            <soft-input
              id="phoneNumber"
              type="phone"
              placeholder="+40 745 765 439"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 align-self-center">
            <label class="form-label mt-2">Language</label>
            <select
              id="choices-language"
              class="form-control"
              name="choices-language"
            >
              <option value="English">English</option>
              <option value="French">French</option>
              <option value="Spanish">Spanish</option>
            </select>
          </div>
          <div class="col-md-6">
            <label class="form-label mt-2">Skills</label>
            <input
              id="choices-skills"
              class="form-control"
              type="text"
              value="vuejs, angular, react"
              placeholder="Enter something"
              onfocus="focused(this)"
              onfocusout="defocused(this)"
            />
          </div>
        </div>
      </div>
    </div>
    <div id="contact-information" class="card mt-4">
      <div class="card-header">
        <h5>{{  $t('key_brand_contact_information') }}</h5>
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <!-- <div class="col-6">
            <label class="form-label text-primary">{{ $t('key_brand_contact_fullname') }} <span style="color:red">*</span></label>
            <Input id="contactFullname" :value="brand?.contact?.name" :error="errors?.contact?.name" :error-message="translate_error(validated, errors?.contact?.name)" :is-required="true" type="text" :placeholder="$t('key_brand_contact_fullname_placeholder')" @update:value="val => setFieldValue('contact.name', val)"/>
          </div>
          <div class="col-6">
            <label class="form-label text-primary">{{ $t('key_brand_contact_vat') }} <span style="color:red">*</span></label>
            <Input id="contactFullname" :value="brand?.contact?.vat" :error="errors?.contact?.vat" :error-message="translate_error(validated, errors?.contact?.vat)" :is-required="true" type="text" :placeholder="$t('key_brand_contact_vat_placeholder')" @update:value="val => setFieldValue('contact.vat', val)"/>
          </div> -->
        </div>
        <div class="row">
          
        </div>
        <!-- <div class="row">
          <div class="col-6">
            <label class="form-label mt-2">Email</label>
            <soft-input id="email" type="email" placeholder="example@email.com" />
          </div>
          <div class="col-6">
            <label class="form-label mt-2">Confirmation Email</label>
            <soft-input
              id="confirmEmail"
              type="email"
              placeholder="example@email.com"
            />
          </div>






          
        </div> -->
        <!-- <div class="row">
          <div class="col-6">
            <label class="form-label mt-2">Email</label>
            <soft-input id="email" type="email" placeholder="example@email.com" />
          </div>
          <div class="col-6">
            <label class="form-label mt-2">Confirmation Email</label>
            <soft-input
              id="confirmEmail"
              type="email"
              placeholder="example@email.com"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <label class="form-label mt-2">Your location</label>
            <soft-input id="location" type="text" placeholder="Sydney, A" />
          </div>
          <div class="col-6">
            <label class="form-label mt-2">Phone Number</label>
            <soft-input
              id="phoneNumber"
              type="phone"
              placeholder="+40 745 765 439"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 align-self-center">
            <label class="form-label mt-2">Language</label>
            <select
              id="choices-language"
              class="form-control"
              name="choices-language"
            >
              <option value="English">English</option>
              <option value="French">French</option>
              <option value="Spanish">Spanish</option>
            </select>
          </div>
          <div class="col-md-6">
            <label class="form-label mt-2">Skills</label>
            <input
              id="choices-skills"
              class="form-control"
              type="text"
              value="vuejs, angular, react"
              placeholder="Enter something"
              onfocus="focused(this)"
              onfocusout="defocused(this)"
            />
          </div>
        </div> -->
        <soft-button
          class="float-end mt-6 mb-0"
          type="submit"
          color="primary"
          variant="gradient"
          size="sm"
          >update info</soft-button
        >
      </div>
      
      
      
      
      
      

    </div>
    <div id="2fa" class="card mt-4">
      <div class="card-header d-flex">
        <h5 class="mb-0">Two-factor authentication</h5>
        <soft-badge color="success" class="ms-auto">Enabled</soft-badge>
      </div>
      <div class="card-body">
        <div class="d-flex">
          <p class="my-auto">Security keys</p>
          <p class="text-secondary text-sm ms-auto my-auto me-3">
            No Security Keys
          </p>
          <soft-button
            color="primary"
            variant="outline"
            size="sm"
            class="mb-0"
            type="button"
            >Add</soft-button
          >
        </div>
        <hr class="horizontal" />
        <div class="d-flex">
          <p class="my-auto">SMS number</p>
          <p class="text-secondary text-sm ms-auto my-auto me-3">+4012374423</p>
          <soft-button
            color="primary"
            variant="outline"
            size="sm"
            class="mb-0"
            type="button"
            >Edit</soft-button
          >
        </div>
        <hr class="horizontal" />
        <div class="d-flex">
          <p class="my-auto">Authenticator app</p>
          <p class="text-secondary text-sm ms-auto my-auto me-3">
            Not Configured
          </p>
          <soft-button
            color="primary"
            variant="outline"
            size="sm"
            class="mb-0"
            type="button"
            >Set up</soft-button
          >
        </div>
      </div>
    </div>
    <div id="accounts" class="card mt-4">
      <div class="card-header">
        <h5>Accounts</h5>
        <p class="text-sm">
          Here you can setup and manage your integration settings.
        </p>
      </div>
      <div class="card-body pt-0">
        <div class="d-flex">
          <soft-avatar class="width-48-px" :img="img1" alt="logo_slack" />
          <div class="my-auto ms-3">
            <div class="h-100">
              <h5 class="mb-0">Slack</h5>
              <a class="text-sm text-body" href="javascript:;">
                Show less
                <i class="fas fa-chevron-up text-xs ms-1" aria-hidden="true"></i>
              </a>
            </div>
          </div>
          <p class="text-sm text-secondary ms-auto me-3 my-auto">Enabled</p>
          <div class="my-auto">
            <soft-switch id="slack" name="showMore" checked />
          </div>
        </div>
        <div class="ps-5 pt-3 ms-3">
          <p class="mb-0 text-sm">
            You haven't added your Slack yet or you aren't authorized. Please add
            our Slack Bot to your account by clicking on
            <a href="javascript">here</a>. When you've added the bot, send your
            verification code that you have received.
          </p>
          <div
            class="d-sm-flex align-items-center bg-gray-100 border-radius-lg p-2 my-4"
          >
            <p class="text-sm font-weight-bold my-auto ps-sm-2">
              Verification Code
            </p>
            <soft-input
              type="text"
              value="1172913"
              class="my-auto w-20 ms-sm-auto"
            />
          </div>
          <div class="d-sm-flex bg-gray-100 border-radius-lg p-2 my-4">
            <p class="text-sm font-weight-bold my-auto ps-sm-2">
              Connected account
            </p>
            <h6 class="text-sm ms-auto me-3 my-auto">hello@hotaka.io</h6>
            <soft-button
              color="danger"
              variant="gradient"
              size="sm"
              class="my-sm-auto mt-2 mb-0"
              type="button"
              name="button"
              >Delete</soft-button
            >
          </div>
        </div>
        <hr class="horizontal" />
        <div class="d-flex">
          <soft-avatar class="width-48-px" :img="img2" alt="logo_spotify" />
          <div class="my-auto ms-3">
            <div class="h-100">
              <h5 class="mb-0">Spotify</h5>
              <p class="mb-0 text-sm">Music</p>
            </div>
          </div>
          <p class="text-sm text-secondary ms-auto me-3 my-auto">Enabled</p>
          <div class="my-auto">
            <soft-switch id="spotify" name="show" checked />
          </div>
        </div>
        <hr class="horizontal" />
        <div class="d-flex">
          <soft-avatar class="width-48-px" :img="img3" alt="logo_atlassian" />
          <div class="my-auto ms-3">
            <div class="h-100">
              <h5 class="mb-0">Atlassian</h5>
              <p class="mb-0 text-sm">Payment vendor</p>
            </div>
          </div>
          <p class="text-sm text-secondary ms-auto me-3 my-auto">Enabled</p>
          <div class="my-auto">
            <soft-switch id="atlassian" name="showMore2" checked />
          </div>
        </div>
        <hr class="horizontal" />
        <div class="d-flex">
          <soft-avatar class="width-48-px" :img="img4" alt="logo_asana" />
          <div class="my-auto ms-3">
            <div class="h-100">
              <h5 class="mb-0">Asana</h5>
              <p class="mb-0 text-sm">Organize your team</p>
            </div>
          </div>
          <div class="my-auto ms-auto">
            <soft-switch id="Asana" name="showMore3" />
          </div>
        </div>
      </div>
    </div>
    <div id="notifications" class="card mt-4">
      <div class="card-header">
        <h5>Notifications</h5>
        <p class="text-sm">
          Choose how you receive notifications. These notification settings apply
          to the things you’re watching.
        </p>
      </div>
      <div class="card-body pt-0">
        <div class="table-responsive">
          <table class="table mb-0">
            <thead>
              <tr>
                <th class="ps-1" colspan="4">
                  <p class="mb-0">Activity</p>
                </th>
                <th class="text-center">
                  <p class="mb-0">Email</p>
                </th>
                <th class="text-center">
                  <p class="mb-0">Push</p>
                </th>
                <th class="text-center">
                  <p class="mb-0">SMS</p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="ps-1" colspan="4">
                  <div class="my-auto">
                    <span class="text-primary d-block text-sm">Mentions</span>
                    <span class="text-xs font-weight-normal"
                      >Notify when another user mentions you in a comment</span
                    >
                  </div>
                </td>
                <td>
                  <div class="ms-auto">
                    <soft-switch
                      id="mentionsEmail"
                      name="mentionsEmail"
                      checked
                    />
                  </div>
                </td>
                <td>
                  <div class="ms-auto">
                    <soft-switch id="mentionsPush" name="mentionsPush" />
                  </div>
                </td>
                <td>
                  <div class="ms-auto">
                    <soft-switch id="mentionsSms" name="mentionsSms" />
                  </div>
                </td>
              </tr>
              <tr>
                <td class="ps-1" colspan="4">
                  <div class="my-auto">
                    <span class="text-primary d-block text-sm">Comments</span>
                    <span class="text-xs font-weight-normal"
                      >Notify when another user comments your item.</span
                    >
                  </div>
                </td>
                <td>
                  <div class="ms-auto">
                    <soft-switch
                      id="commentsEmail"
                      name="commentsEmail"
                      checked
                    />
                  </div>
                </td>
                <td>
                  <div class="ms-auto">
                    <soft-switch id="commentsPush" name="commentsPush" checked />
                  </div>
                </td>
                <td>
                  <div class="ms-auto">
                    <soft-switch id="commentsSms" name="commentsSms" />
                  </div>
                </td>
              </tr>
              <tr>
                <td class="ps-1" colspan="4">
                  <div class="my-auto">
                    <span class="text-primary d-block text-sm">Follows</span>
                    <span class="text-xs font-weight-normal"
                      >Notify when another user follows you.</span
                    >
                  </div>
                </td>
                <!-- <td>
                  <div class="ms-auto">
                    <soft-switch id="followsEmail" name="followsEmail" checked />
                  </div>
                </td>
                <td>
                  <div class="ms-auto">
                    <soft-switch id="followsEmail" name="followsPush" checked />
                  </div>
                </td>
                <td>
                  <div class="ms-auto">
                    <soft-switch id="followsEmail" name="followsSms" checked />
                  </div>
                </td> -->
              </tr>
              <tr>
                <td class="ps-1" colspan="4">
                  <div class="my-auto">
                    <p class="text-sm mb-0">Log in from a new device</p>
                  </div>
                </td>
                <td>
                  <div class="ms-auto">
                    <soft-switch id="deviceEmail" name="deviceEmail" checked />
                  </div>
                </td>
                <td>
                  <div class="ms-auto">
                    <soft-switch id="devicePush" name="devicePush" checked />
                  </div>
                </td>
                <td>
                  <div class="ms-auto">
                    <soft-switch id="deviceSms" name="deviceSms" checked />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div id="sessions" class="card mt-4">
      <div class="card-header pb-3">
        <h5>Sessions</h5>
        <p class="text-sm">
          This is a list of devices that have logged into your account. Remove
          those that you do not recognize.
        </p>
      </div>
      <div class="card-body pt-0">
        <div class="d-flex align-items-center">
          <div class="text-center w-5">
            <i class="fas fa-desktop text-lg opacity-6"></i>
          </div>
          <div class="my-auto ms-3">
            <div class="h-100">
              <p class="text-sm mb-1">Bucharest 68.133.163.201</p>
              <p class="mb-0 text-xs">Your current session</p>
            </div>
          </div>
          <soft-badge color="success" size="sm" class="my-auto ms-auto me-3"
            >Active</soft-badge
          >
          <p class="text-secondary text-sm my-auto me-3">EU</p>
          <a
            href="javascript:;"
            class="text-primary text-sm icon-move-right my-auto"
          >
            See more
            <i class="fas fa-arrow-right text-xs ms-1" aria-hidden="true"></i>
          </a>
        </div>
        <hr class="horizontal" />
        <div class="d-flex align-items-center">
          <div class="text-center w-5">
            <i class="fas fa-desktop text-lg opacity-6"></i>
          </div>
          <p class="my-auto ms-3">Chrome on macOS</p>
          <p class="text-secondary text-sm ms-auto my-auto me-3">US</p>
          <a
            href="javascript:;"
            class="text-primary text-sm icon-move-right my-auto"
          >
            See more
            <i class="fas fa-arrow-right text-xs ms-1" aria-hidden="true"></i>
          </a>
        </div>
        <hr class="horizontal" />
        <div class="d-flex align-items-center">
          <div class="text-center w-5">
            <i class="fas fa-mobile text-lg opacity-6"></i>
          </div>
          <p class="my-auto ms-3">Safari on iPhone</p>
          <p class="text-secondary text-sm ms-auto my-auto me-3">US</p>
          <a
            href="javascript:;"
            class="text-primary text-sm icon-move-right my-auto"
          >
            See more
            <i class="fas fa-arrow-right text-xs ms-1" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </div>
    <div id="delete" class="card mt-4">
      <div class="card-header">
        <h5>Delete Account</h5>
        <p class="text-sm mb-0">
          Once you delete your account, there is no going back. Please be certain.
        </p>
      </div>
      <div class="card-body d-sm-flex pt-0">
        <div class="d-flex align-items-center mb-sm-0 mb-4">
          <div>
            <soft-switch id="deleteAccount" name="deleteAccount" />
          </div>
          <div class="ms-2">
            <span class="text-primary font-weight-bold d-block text-sm"
              >Confirm</span
            >
            <span class="text-xs d-block">I want to delete my account.</span>
          </div>
        </div>
        <soft-button
          color="secondary"
          variant="outline"
          class="mb-0 ms-auto"
          type="button"
          name="button"
          >Deactivate</soft-button
        >
        <soft-button
          color="danger"
          variant="gradient"
          class="mb-0 ms-2"
          type="button"
          name="button"
          >Delete Account</soft-button
        >
      </div>
    </div>
  </form>
</template>

<script>

  // IMPORTS
  import Input from "./../../../../../generic_components/Input.vue";

  import { mapState, mapActions } from "vuex";
  import { brandSchema, brandDefaults } from "./../../../schemas/brand_schema.js";



  import * as Choices from "choices.js";
  import SoftButton from "@/components/SoftButton.vue";
  import SoftSwitch from "@/components/SoftSwitch.vue";
  import SoftBadge from "@/components/SoftBadge.vue";
  import SoftAvatar from "@/components/SoftAvatar.vue";
  import SoftInput from "@/components/SoftInput.vue";
  import img from "./../../../../../../assets/img/bruce-mars.jpg";
  import img1 from "./../../../../../../assets/img/small-logos/logo-slack.svg";
  import img2 from "./../../../../../../assets/img/small-logos/logo-spotify.svg";
  import img3 from "./../../../../../../assets/img/small-logos/logo-atlassian.svg";
  import img4 from "./../../../../../../assets/img/small-logos/logo-asana.svg";





  export default {
    name: "BrandSideMenuItem",
    components: {
      Input,






      SoftButton,
      SoftSwitch,
      SoftBadge,
      SoftAvatar,
      SoftInput,
    },

    /* setup() {

      //const validated = ref(false);

      const { values, errors, validate, setFieldValue } = useForm({
        validationSchema: toTypedSchema(brandSchema),
        validateOnMount: true,
        validateOnBlur: true,
        validateOnChange: false,
        validateOnInput: false,
        initialValues: { ...brandDefaults },
        initialErrors: {},
      });

      console.log(values);

      const onSubmit = async () => {
        const result = await validate();
        validated.value = true;

        if (!result.valid) {
          alert("⚠️ El formulario contiene errores. Por favor, revisa los campos.");
          return;
        }

        if (this.brand_id) {
          console.log("update");
        } else {
          console.log("insert");
          await newBrand()
        }

        console.log("✅ Datos validados:", values);
        alert("Formulario válido. Datos enviados correctamente.");
      };

      return { onSubmit, values, errors, validated, setFieldValue };
    }, */
    data() {
      return {
        isLoading: false,
        isSaving: false,
        validated: false,
        brand_id: this.$route.params.id || null,
        brand: { ...brandDefaults },
        errors: {},





        img,
        img1,
        img2,
        img3,
        img4,
      };
    },



    
    







    computed: {
      ...mapState('brandAdmin', {
        newBrandData: state => state.newBrand.data,
        newBrandResponse: state => state.newBrand.response,
        newBrandStatus: state => state.newBrand.status,
      }),
      brand_title() {
        return this.brand_id === null ? this.$t('key_brand_new') : this.$t('key_brand_edit');
      },
    },
    mounted() {
      if (this.isEditing) {
        this.loadBrand();
      }

      /* if(this._id){ //Cargar elemento
        this.$store.commit("products/getById",this.$route.params.id);
      } */

      if (document.getElementById("choices-gender")) {
        var gender = document.getElementById("choices-gender");
        new Choices(gender);
      }

      if (document.getElementById("choices-language")) {
        var language = document.getElementById("choices-language");
        new Choices(language);
      }

      if (document.getElementById("choices-brand-category")) {
        var category = document.getElementById("choices-brand-category");
        setTimeout(function () {
          new Choices(category);
        }, 1);

        var CategoryArray = new Array();
        CategoryArray[0] = "January";
        CategoryArray[1] = "February";
        
        for (let m = 0; m <= 1; m++) {
          var optn = document.createElement("OPTION");
          optn.text = CategoryArray[m];

          optn.value = m + 1;
          if (m == 1) {
            optn.selected = true;
          }
          category.options.add(optn);
        }
      }

      if (document.getElementById("choices-day")) {
        var day = document.getElementById("choices-day");
        setTimeout(function () {
          new Choices(day);
        }, 1);

        for (let y = 1; y <= 31; y++) {
          var optn1 = document.createElement("OPTION");
          optn1.text = y;
          optn1.value = y;

          if (y == 1) {
            optn1.selected = true;
          }

          day.options.add(optn1);
        }
      }

      if (document.getElementById("choices-year")) {
        var year = document.getElementById("choices-year");
        setTimeout(function () {
          new Choices(year);
        }, 1);

        for (let y = 1900; y <= 2020; y++) {
          var optn2 = document.createElement("OPTION");
          optn2.text = y;
          optn2.value = y;

          if (y == 2020) {
            optn.selected = true;
          }

          year.options.add(optn2);
        }
      }

      if (document.getElementById("choices-skills")) {
        var skills = document.getElementById("choices-skills");
        new Choices(skills, {
          delimiter: ",",
          editItems: true,
          maxItemCount: 5,
          removeItemButton: true,
          addItems: true,
        });
      }
    },
    methods: {
      ...mapActions('brandAdmin', [
                                    'insertBrand',
                                  ]),
      async validateForm() {
        try {
          brandSchema.parse(this.brand);
          this.errors = {};
          return true;
        } catch (e) {
          this.errors = e.errors.reduce((acc, err) => {
            acc[err.path.join('.')] = err.message;
            return acc;
          }, {});
          return false;
        }
      },
      async onSubmit() {
        const valid = await this.validateForm();
        this.validated = true;

        if (!valid) {
          alert("⚠️ El formulario contiene errores. Por favor, revisa los campos.");
          return;
        }

        if (this.brand_id) {
          console.log("update");
        } else {
          await this.newBrand();
        }
      },
      translate_error(validated, value) {
        console.log(value)
        if (!value || !validated) return '';

        if (typeof val === 'object') {
          if (value.message && typeof value.message === 'string') return this.$t(value.message);
          if (value.key && typeof value.key === 'string') return this.$t(value.key);
          return '';
        }

        if (typeof val === 'string') return this.$t(value);

        console.log(value);
        console.log(this.$t(value))
        if (typeof value === 'string' && value.length > 0) {
          return this.$t(value);
        }
      },
      async newBrand() {
        if (this.newBrandStatus === 'waiting' || this.isSaving) {
          return;
        }
        this.isSaving = true;

        try {
          const payload = brandSchema.parse(this.brand);
          await this.insertBrand(payload);
          console.log(this.newBrandStatus)
          console.log(this.newBrandResponse)
          console.log(this.newBrandData)
          if (this.newBrandStatus === 'success' && this.newBrandData.status_code === 201) {
            this.$notify({
              title: this.newBrandData.message,
              message: this.newBrandData.details,
              icon: { component: 'fa-solid fa-check', color: 'white' },
              color: 'success',
              show: true,
              duration: 5000,
            });
            this.open_created_brand(this.newBrandData.data.inserted_id);
          } else if(this.brandsStatus !== 'success') {
            this.$notify({
              title: this.newBrandData.message,
              message: this.newBrandData.details,
              icon: { component: 'fa-solid fa-xmark', color: 'white' },
              color: 'danger',
              show: true,
              duration: 5000,
            });
          } else {
            this.$notify({
              title: this.newBrandData.message,
              message: this.newBrandData.details,
              icon: { component: 'fa-solid fa-xmark', color: 'white' },
              color: 'danger',
              show: true,
              duration: 5000,
            });
          }
        } catch (error) {
          this.$notify({
            title: this.$t('key_header_error_unexpected'),
            message: this.$t('key_message_error_unexpected'),
            icon: { component: 'fa-solid fa-xmark', color: 'white' },
            color: 'danger',
            show: true,
            duration: 5000,
          });
        } finally {
          this.isSaving = false;
        }
      },
      open_created_brand(id) {
        if (id) {
          this.$router.push({ path: "/CustomerService/Customers/BrandDetails/" + id});
        }
      },
    },
  };

</script>
